import { UserStatus } from '@/models';
import { RouterLocation } from '@/router';
import { RootStore } from '@/store';
import { Route } from 'vue-router';

function redirect(to: Route, next: RouterLocation, userStatus: UserStatus) {
  if (to.params.errorMessageKey) {
    next();
    return;
  }

  next({
    name: 'access-denied-page',
    params: { errorMessageKey: userStatus },
  });
}

export const userGuard = (to: Route, __: Route, next: RouterLocation) => {
  switch (RootStore.state.users.currentUserStatus) {
    case UserStatus.Inactive:
      return redirect(to, next, UserStatus.Inactive);
    case UserStatus.PendingRequest:
      return redirect(to, next, UserStatus.PendingRequest);
    case UserStatus.Declined:
      return redirect(to, next, UserStatus.Declined);
    default:
      next();
  }
};
